import FinancePayments from './payments/Payments'
import FinancePaymentsView from './payments/View'
import FinancePaymentsCreate from './payments/Create'

const Modules = {
    FinancePayments,
    FinancePaymentsView,
    FinancePaymentsCreate,
}

export default Modules
